module.exports = [
  '$resource',
  function GroupResource(
    $resource,
  ) {
    const ResourceObject = $resource('/api/v2/groups/:id/public',
      {
        id: '@id',
      },
      {
        get: {
          method: 'get',
        },
      },
    );

    angular.extend(ResourceObject.prototype, {
      $clone(value) {
        return new ResourceObject(Object.assign(value || {}, this));
      },
    });

    return ResourceObject;
  },
];



// WEBPACK FOOTER //
// ./main/factories/group-resource.js